/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CreatedDate/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentHover from 'DesignSystem/Popover/PopoverContentHover/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import Tooltip from 'DesignSystem/Tooltip/index'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function CreatedDate({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/Board/Board/Content/Card/CreatedDate"
  
}) {
let constantData = 'Created '
let cardCreatedAtValueData = fromData.useDataFormat({ viewPath,
context: 'card',
path: 'created_at',
format: fromFormat.dateISOToDateShortReporting,
})
let aggregateData = fromAggregate.join(constantData, cardCreatedAtValueData)
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let cardCreatedAtValueData1 = fromData.useDataFormat({ viewPath,
context: 'card',
path: 'created_at',
format: fromFormat.dateISOToTime,
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
 offsetMainAxis={0}
 placement="right"
 showOnHover={true}
 showOnClick={false}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 size="tiny"
 color={dtColorsNeutral600}
 data="'Created '"
 data="card.created_at"
 format="/Data/format.js dateISOToDateShortReporting"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
)}
</PopoverTrigger>
<PopoverContentHover
{...childProps}
  viewPath={`${viewPath}/PopoverContentHover`}
>
{childProps => (
<Tooltip
{...childProps}
  viewPath={`${viewPath}/Tooltip`}
 backgroundColor={dtColorsWhite}
 color={dtColorsNeutral500}
 height="auto"
 size="small"
 className="new-shadow"
 whiteSpace="normal"
 data="card.created_at"
 format="/Data/format.js dateISOToTime"
 text={cardCreatedAtValueData1}
 className="new-shadow"
/>
)}
</PopoverContentHover>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}